var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"value":_vm.computedValue,"options":_vm.options,"searchable":false,"showLabels":false},on:{"input":_vm.onChange},scopedSlots:_vm._u([{key:"option",fn:function({option}){return [_vm._v("\n    "+_vm._s(option)+"%\n  ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }